<template>
  <div id="app" v-bind:class="{ 'light-theme': !darkTheme, 'dark-theme': darkTheme }">
    <router-view />
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import "@fortawesome/fontawesome-free/css/all.css"
import Header from "./components/Header.vue"
import Footer from "./components/Footer.vue"

export default {
  name: "App",
  data() {
    return {
      darkTheme: false,
    }
  },
  mounted() {
    this.darkTheme = localStorage.getItem("darkTheme")
  },
  components: {
    Header,
    Footer,
  },
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap");

.dark-theme {
  --background-primary: #393939;
  --background-secondary: #2d2d2d;
  --font-color-primary: #eee;
  --font-color-secondary: #c7c7c7;
  --border-color: #7c7c7c;
  --font-color-700: #bbb;
  --font-color-600: #aaa;
  --font-color-500: #999;
  --font-color-400: #888;
  --font-color-300: #777;
  --font-color-200: #666;
  --font-color-100: #555;
  --primary-green: #00c781;
  --primary-orange-yellow: #ffb549;
  --primary-blue: #10a2e6;
}

.light-theme {
  --background-primary: #fafafa;
  --background-secondary: #fff;
  --font-color-primary: #555;
  --font-color-secondary: #808080;
  --border-color: #e0e0e0;
  --font-color-700: #555;
  --font-color-600: #666;
  --font-color-500: #777;
  --font-color-400: #888;
  --font-color-300: #999;
  --font-color-200: #aaa;
  --font-color-100: #bbb;
  --primary-green: #00c781;
  --primary-orange-yellow: #ffa41c;
  --primary-blue: #10a2e6;
}

.border {
  border-color: var(--border-color) !important;
}

#app {
  font-family: "Inter", sans-serif;
  color: var(--font-color-primary);
  background-color: var(--background-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

.text-muted {
  color: var(--font-color-600) !important;
}

small {
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue